import React from "react"
import Container from "../Container"
import { Props } from "./props"

const CrowdLamp: React.FC<Props> = (props) => (
  <Container contentType="help" {...props} />
)
export default CrowdLamp
